export const CREATE_SOURCES = {
  ADD_VIDEO: 'Add Video',
  CHANNEL_CARD: 'Channel Card'
};
